import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import type { I18nRemoveActorDialogKey } from './types';

const i18n: Record<I18nRemoveActorDialogKey, MessageDescriptor> = defineMessages({
	iconLabel: {
		id: 'users-and-roles.actors-table.remove-actor-dialog.icon-label',
		defaultMessage: 'Warning',
		description: 'Label for the warning icon in the remove actor dialog.',
	},
	removeActorHeader: {
		id: 'users-and-roles.actors-table.remove-actor-dialog.remove-actor-header',
		defaultMessage: 'Remove {userOrGroupDisplayName}',
		description: 'Header for the remove actor dialog',
	},
	removeButtonLabel: {
		id: 'users-and-roles.actors-table.remove-actor-dialog.remove-button-label',
		defaultMessage: 'Remove',
		description: 'Button text for remove actor dialog.',
	},
	removeButtonLabelPermissionGated: {
		id: 'users-and-roles.actors-table.remove-actor-dialog.remove-button-label-permission-gated',
		defaultMessage: 'Remove anyway',
		description: 'Button text for remove actor dialog when permission is gated.',
	},
	cancelButtonLabel: {
		id: 'users-and-roles.actors-table.remove-actor-dialog.cancel-button-label',
		defaultMessage: 'Cancel',
		description: 'Button text for cancelling the remove actor dialog.',
	},
	userRemovalConfirmationMessage: {
		id: 'users-and-roles.actors-table.remove-actor-dialog.user-removal-confirmation-message',
		defaultMessage: "{userFullName} won't be able to work on this project anymore.",
		description:
			'Message shown in the dialog box explaining that a user cannot work on this project anymore if removed.',
	},
	groupRemovalConfirmationMessage: {
		id: 'users-and-roles.actors-table.remove-actor-dialog.group-removal-confirmation-message',
		defaultMessage: "Members of {groupName} won't be able to work on this project anymore.",
		description:
			'Message shown in the dialog box explaining that users belonging to this group cannot work on this project anymore if removed.',
	},
	userRemovalConfirmationMessagePermissionGated: {
		id: 'users-and-roles.actors-table.remove-actor-dialog.user-removal-confirmation-message-permission-gated',
		defaultMessage:
			'This user still has access to the project while you’re on the Free plan. To remove project access, you need to remove them in site administration.',
		description:
			'Message shown in the dialog box explaining that a user cannot work on this project anymore if removed when permission is gated.',
	},
	groupRemovalConfirmationMessagePermissionGated: {
		id: 'users-and-roles.actors-table.remove-actor-dialog.group-removal-confirmation-message-permission-gated',
		defaultMessage:
			'Group members still have access to the project while you’re on the Free plan. To remove project access, remove users in site administration.',
		description:
			'Message shown in the dialog box explaining that users belonging to this group cannot work on this project anymore if removed when permission is gated.',
	},
});

export default i18n;
